import { IoCheckmark, IoClose, IoDocument, IoDocumentText, IoDocumentTextOutline } from 'react-icons/io5';
import './SubtaskHeader.css';
import FieldUpdate from '../../../../components/SVG/FieldUpdate';
import FieldSvg from '../../../../components/SVG/FieldSvg';
import '../../styles/variables.css';
import DocumentIconSvg from '../../../../components/SVG/DocumentIconSvg';
import AudioIconSvg from '../../../../components/SVG/AudioIconSvg';
import VideoIconSvg from '../../../../components/SVG/VideoIconSvg';
import PhotoIconSvg from '../../../../components/SVG/PhotoIconSvg';
import { Calendar } from 'react-bootstrap-icons';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getSingleTask } from '../../../../redux/TaskReducer/action';
import { isAuthorised } from '../../../../utils/common';
import { TASK_MANAGEMENT_COMPONENTS } from '../../../../config/task_management';
import { useState } from 'react';
import { getAuthToken } from "../../../../utils/auth";

const Header = ({ subtask }) => {
   const { officerProfile } = useSelector((store) => {
      return {
        officerProfile: store.UserReducer.officerProfile
      }
  }, []);

  // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || JSON.parse(localStorage.getItem("tokens")) || null;
  // let authToken = tokens?.token || null;
  let authToken = getAuthToken();

  const dispatch = useDispatch();

  const [actionLoading, setActionLoading] = useState({});

  let subtaskStatusId = subtask?.status?.status_id;

  const handleTaskStatusUpdate = async (newStatusId, actionKey) => {
    if (actionLoading[actionKey]) return;

    if (!authToken) {
      toast.error(`Invalid or missing token.`);
      return;
    }

    setActionLoading(prev => ({
      ...prev,
      [actionKey]: true
    }));

    let headers = {
      'Authorization': `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    }

    let newTaskStatusObj = {
      sub_task_id: subtask?.sub_task_id,
      new_status_id: newStatusId
    }

    try {
      let response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/task/sub-task/change-status`, newTaskStatusObj, { headers });

      if(response?.data?.data){
        toast.success(`Subtask status changed successfully.`);

        dispatch(getSingleTask(subtask?.parent_task_id));
      }
    }
    catch (error) {
      // toast.error("Error in changing subtask status", error);
      toast.error(`${error?.response?.data?.message}`);
    }
    finally {
      setActionLoading(prev => ({
        ...prev,
        [actionKey]: false
      }));
    }
  }

  return (
    <div className="subtask-header">
      <div className="subtask-topic">
        <div className="subtask-header-icon">
          {
            subtask?.task_type?.type_code === 'FIELD' &&
            <FieldSvg fillColor={"var(--icon-color)"} size={24} />
          }
          {
            subtask?.task_type?.type_code === 'DOCUMENT' &&
            <DocumentIconSvg fillColor={"var(--icon-color)"} size={24} />
          }
          {
            subtask?.task_type?.type_code === 'AUDIO' &&
            <AudioIconSvg fillColor={"var(--icon-color)"} size={24} />
          }
          {
            subtask?.task_type?.type_code === 'VIDEO' &&
            <VideoIconSvg fillColor={"var(--icon-color)"} size={24} />
          }
          {
            subtask?.task_type?.type_code === 'PHOTO' &&
            <PhotoIconSvg fillColor={"var(--icon-color)"} size={24} />
          }
        </div>
        <div className="subtask-details-wrapper">
          <div className="subtask-title-area">
            <h4>{subtask.title}</h4>
            <span className="subtask-id-badge">{subtask.readable_sub_task_id}</span>
          </div>
          <div className='subtask-info-container'>
            {subtask?.category && 
              <div className='subtask-topic-info'>
                <IoDocumentTextOutline />
                {subtask?.category?.category_name}
              </div>
            }
            {subtask?.due_date &&
              <div className='subtask-topic-info'>
                <Calendar />
                {subtask?.due_date?.split('T')?.[0]}
              </div>
            }
            {subtask?.assignee &&
              <div className='subtask-topic-info'>
                Assigned to: {subtask.assignee.name}
                {subtask.assignee.designation ? ` (${subtask.assignee.designation})` : ''}
              </div>
            }
          </div>
        </div>
      </div>

      <div className="subtask-header-right">
        <span className={`status-pill status-${subtask?.status?.status_code?.toLowerCase()}`}>
          {subtask?.status?.status_name}
        </span>
        {([5].includes(Number(subtaskStatusId))) && (
          <div className="actions">
            {isAuthorised(
              officerProfile,
              TASK_MANAGEMENT_COMPONENTS?.approve_task
            ) && (
              <button 
                className="approve"
                onClick={() => handleTaskStatusUpdate(9, 'approve')}
                disabled={actionLoading.approve || actionLoading.reject}
              >
                {actionLoading.approve ? (
                  <>
                    <span className="buttonSpinner"></span>
                    Approving...
                  </>
                ) : (
                  <>
                    <IoCheckmark /> Approve
                  </>
                )}
              </button>
            )}
            {isAuthorised(
              officerProfile,
              TASK_MANAGEMENT_COMPONENTS?.reject_task
            ) && (
              <button 
                className="reject"
                onClick={() => handleTaskStatusUpdate(10, 'reject')}
                disabled={actionLoading.reject || actionLoading.approve}
              >
                {actionLoading.reject ? (
                  <>
                    <span className="buttonSpinner"></span>
                    Rejecting...
                  </>
                ) : (
                  <>
                    <IoClose /> Reject
                  </>
                )}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;